<!--
일괄기능-마감작업
------------------------------------

-->
<template>
<div class="">
    
    <div class="uk-text-center uk-text-large uk-margin-bottom">
        선택한 BOX들을 일괄로 마감처리 합니다.<br />
      <span class="uk-text-danger">작업시간이 부족한 긴급한 경우에만 사용하세요</span>
    </div>
    


    <!-- 버튼영역 -->
    <div class="uk-text-center">        
        <button 
            class="uk-button uk-button-primary  uk-button-large2"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.done.jobInit()"
        >
            <i class="material-icons uk-text-middle">assignment_turned_in</i>
            <span class="uk-text-middle">CLOSING (마감완료)</span>
        </button>
    </div>
    
    <!-- DONE 기능 -->
    <app-batch-job-end-done
        ref="done"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></app-batch-job-end-done>   
    
</div>
    
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>